import { Injectable } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";
import { environment as ENV } from "@environments/environment";

@Injectable()
export class SSOService {
  constructor(public auth: AuthService, private http: HttpClient) {}

  public fetchUserData(token: string): Observable<any> {
    if (!token || token === "undefined" || token.trim() === "") {
      return throwError("Token is required and cannot be undefined, null or empty");
    }

    return this.http.post(
      `${ENV.gateway.base_url}/cauth/api/turbo/us/user/data-for-admin`,
      "",
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "text/plain;charset=UTF-8",
        },
      }
    ).pipe(
      mergeMap((userData: any) => {
        const roleAuth0Id = userData.roleAuth0Id;
        return this.http.get(
          `${ENV.gateway.base_url}/cauth/api/turbo/us/role/${roleAuth0Id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        ).pipe(
          map((roleData: any) => ({
            ...userData,
            role: roleData?.role?.name ?? roleAuth0Id
          })),
          catchError(() => of({
            ...userData,
            role: roleAuth0Id
          }))
        );
      })
    );
  }
}